import React, { Component } from 'react';
import { Button, Input, Modal, Tooltip } from 'antd';
import PopupAddCustomCoins from './PopupAddCustomCoins';
import { MdAddCircle } from 'react-icons/md';
import actions from '../../redux/actions/setting_data';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

class AddCustomCoinBtnComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
  }
  
  closePopup = () => {
    this.setState({ isVisible: false });
  };
  
  showModal = () => {
    this.setState({ isVisible: true })
  }
  
  render() {
    return (
      <>
        <Button onClick={this.showModal} style={{ size: '2px' }} className="ml-medium">
          <MdAddCircle size="20"/>
          Thêm đồng tùy chọn
        </Button>
        <br/>
        
        <PopupAddCustomCoins isVisible={this.state.isVisible} closePopup={this.closePopup}
                       rowUpdate={this.props.erc20TokenInfo}/>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  erc20TokenInfo: isEmpty(state.setting.erc20TokenInfo) ? undefined : {
    coin: state.setting.erc20TokenInfo.Symbol,
    symbol: state.setting.erc20TokenInfo.Symbol,
    decimal: state.setting.erc20TokenInfo.Decimals,
    name: state.setting.erc20TokenInfo.Name,
    contract_address: state.setting.erc20TokenInfo.Contract,
    type: 'erc20',
  },
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AddCustomCoinBtnComponent);

